/* global ViewController, WebView */
var publicFormLinkController = new ViewController({
    directory : "views/public",
    name: "publicFormLink",
    container: "main",
    route: "form-public"
}) ;

publicFormLinkController.prepareDataOnEnter = async function(data){
  return {token: data} ;
};

publicFormLinkController.onValidate = async function(){
    this.view.updateData() ;//update data from form
    let token = this.data.token ;
    //run form checks
    let checkOk = await this.view.checkForm(this.view.EL.form) ;
    if (!checkOk) {
        return ;
    }
    let record = this.data ;
    record.id = 5;
    this.view.longTask(function(done){
        this.api.public.updatePublicForm(token, record, function(err){
            if(err){
                return done(err) ;
            }
            WebView.info(WebView.tr("public.formDone")) ;
            this.refresh(done) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = publicFormLinkController ;